import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputFields from "../../utils/UserInput";
import { Modal, message } from "antd";
import { postRequest } from "../../utils/APICall";
import moment from "moment";
import { useSelector } from "react-redux";
import { XMarkIcon } from "@heroicons/react/16/solid";

const DepartForm = ({ visible, onClose }) => {
  const { users } = useSelector((state) => state.user || {})

  const validationSchema = Yup.object().shape({
    vdeptitle: Yup.string().required("Title is required"),
    vtimein: Yup.string().required("TimeIn is required"),
    vtimeout: Yup.string().required("TimeOut is required"),
  });

  const initialValues = {
    vdeptitle: "",
    vtimein: "",
    vtimeout: "",
    vsickleaves: "",
    vcasualleaves: "",
    taskAccess: "",
  };

  const handleSubmit = async (values, { resetForm, setSubmitting }) => {
    function addGracePeriod(timeIn, gracePeriodMinutes) {
      const [hours, minutes] = timeIn.split(':').map(Number);
      const timeInDate = new Date();
      timeInDate.setHours(hours, minutes, 0);
      timeInDate.setMinutes(timeInDate.getMinutes() + gracePeriodMinutes);
      const newTime = timeInDate.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
      return newTime;
    }

    try {
      // old convertor Function 
      //  function convertToISOTime(timeStr) {
      //   const [time, modifier] = timeStr.trim().split(' ');
      //   let [hours, minutes] = time.split(':').map(Number);
      //   if (modifier === 'PM' && hours !== 12) {
      //     hours += 12;
      //   } else if (modifier === 'AM' && hours === 12) {
      //     hours = 0;
      //   }
      //   const now = new Date();
      //   now.setHours(hours, minutes, 0, 0);
      //   return now.toISOString();
      // }
      function convertToISOTime(timeStr) {
        const [time, modifier] = timeStr.trim().split(" ");
        let [hours, minutes] = time.split(":").map(Number);

        if (modifier === "PM" && hours !== 12) {
          hours += 12;
        } else if (modifier === "AM" && hours === 12) {
          hours = 0;
        }

        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");

        const hh = String(hours).padStart(2, "0");
        const mm = String(minutes).padStart(2, "0");

        // Local time ko ISO jaisa format me return karna (without timezone shift)
        return `${year}-${month}-${day}T${hh}:${mm}:00`;
      }

      let time = addGracePeriod(values.vtimein, 15);
      const obj = {
        ...values,
        vgracetimeperiod: convertToISOTime(time),
        vtimein: convertToISOTime(values?.vtimein),
        vtimeout: convertToISOTime(values?.vtimeout),
        vcreatedby: `${users?.FIRSTNAME} ${users?.LASTNAME} | ${moment(Date.now()).format("DD-MM-YYYY HH:mm")}`,
      };
      // console.log(obj)
      const response = await postRequest("addDept", obj);
      if (response.success) {
        message.success("Department added successfully");
        onClose();
        resetForm();
        window.location.reload();
      } else {
        message.error("Failed to add department");
      }
    } catch (error) {
      console.error("Error adding department:", error);
      message.error("An error occurred while submitting the form.");
    } finally{
      setSubmitting(false)
    }
  };

  const showConfirm = (values, formikBag) => {
    Modal.confirm({
      title: 'Confirm Submission',
      content: 'Are you sure you want to add this department?',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => handleSubmit(values, formikBag),
      onCancel: () => formikBag.setSubmitting(false)
    });
  };

  return (
    <Modal
      title={
        <div className="text-xl font-bold text-center pb-3 dark:bg-gray-900 dark:text-gray-100">
          Add Department
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      closeIcon={
        <XMarkIcon
          className={"h-5 w-5  dark:text-white text-black"}
        />
      }
      className="dark:[&_.ant-modal-content]:bg-gray-900"
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, formikBag) => showConfirm(values, formikBag)}
      >
        {({ isValid, dirty, isSubmitting }) => (
          <Form>
            <span className="grid grid-cols-1 gap-2 md:grid-cols-2 text-gray-800 dark:text-gray-200">
              <InputFields
                label="Title"
                type="text"
                placeholder="Department Title"
                name="vdeptitle"
              />
              <InputFields
                label="TimeIn"
                type="time"
                name="vtimein"
              />
              <InputFields
                label="TimeOut"
                type="time"
                name="vtimeout"
              />
              <InputFields
                label="Sick Leave"
                type="number"
                placeholder="Sick Leave"
                name="vsickleaves"
              />
              <InputFields
                label="Casual Leave"
                type="number"
                placeholder="Casual Leave"
                name="vcasualleaves"
              />
              <InputFields
                  label="Task Access"
                  type="checkbox"
                  name="taskAccess"
                />
              <button
                type="submit"
                disabled={!(isValid && dirty) || isSubmitting}
                className="mt-5 flex justify-center items-center mx-auto w-full max-h-8 bg-blue-500 text-white px-4 py-2 rounded"
              >
                {isSubmitting ? "Loading..." : "Submit"}
              </button>
            </span>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default DepartForm;